import { MENU_CHANNELS, MENU_FULFILLMENT_TYPES } from '../constants.js';
import { BaseMenuEntityConfiguration } from '../entityConfigs/index.js';
export default new BaseMenuEntityConfiguration({
    consumable: true,
    filters: [
        {
            name: 'fulfillmentType',
            options: MENU_FULFILLMENT_TYPES,
            type: 'Select',
        },
        {
            name: 'popular',
            type: 'Boolean',
        },
        {
            name: 'upsell',
            type: 'Boolean',
        },
        {
            name: 'channels',
            options: MENU_CHANNELS,
            type: 'Select',
        },
    ],
    hasDescription: true,
    hasHours: false,
    hasImage: true,
    hasVariations: true,
    hasPos: true,
    hasPresentation: true,
    lists: [
        {
            collection: 'ModifierSet',
            name: 'modifierSets',
            primaryRelationship: true,
        },
    ],
    name: 'Item',
    options: {
        nutritionalInformation: {
            minCalories: null,
            maxCalories: null,
        },
        points: null,
        popular: false,
        slug: 'placeholder',
        upsell: false,
        experiments: undefined,
        channels: ['pos', 'online', 'marketplace'],
        imageRecommendationScore: undefined,
        excludeFromThrottle: false,
        primaryImageSource: null,
    },
    pluralizedName: 'Items',
    sellable: true,
    sortKeys: ['points'],
    unlinkedOptions: [],
    version: 24,
});
//# sourceMappingURL=item.js.map